<template>
  <div class="quiz-header">
    <div class="step-header">
      <div class="step-container">
        <ul class="stepList">
          <li :class="[getCompletedStep >= 0 ? 'item-completed' : '']" class="first">
            Step 1
          </li>
          <li :class="[getCompletedStep >= 3 ? 'item-completed' : '']" class="second">
            Step 2
          </li>
          <li :class="[getCompletedStep >= 6 ? 'item-completed' : '']" class="third">
            Step 3
          </li>
        </ul>
        <div class="step-comments">
          <div class="step-comment comment-1" v-if="getCompletedStep >= 0">
            <b>Foundational Screening</b>
          </div>
          <div class="step-comment comment-2" v-if="getCompletedStep >= 3">
            <b>Supplementary Screenings</b>
          </div>
          <div class="step-comment comment-3" v-if="getCompletedStep >= 6">
            <b>Finish</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex';
import swal from 'sweetalert';

export default {
  name: "QuizHeader",

  computed: {
    ...mapGetters( [
      'getCompletedStep', 'getQuizCompleted'
    ] ),
  },

  methods: {
    ...mapMutations( [
      'setStep'
    ] ),

    gotoStep( index ) {
      if ( this.getQuizCompleted ) {
        this.setStep( index );
        return;
      } else if ( index <= this.getCompletedStep ) {
        this.setStep( index );
        return;
      }

      swal( "Warning!", "Please complete previous steps first", "warning" );
    }
  }
}
</script>
<style scoped>

.quiz-header {
  width: 100%;
  margin: 0 auto 1.5rem auto;
  text-align: center;
  padding: 0;
}

.stepList {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.step-comments {
  display: flex;
  width: 100%;
}

.step-comment {
  background-color: var(--imc-secondary-color);
  color: #fff;
  padding: 0.5rem 1.5rem;
  font-size: 0.8rem;
}

.comment-2,
.comment-3 {
  margin-left: 2px;
}

.first,
.second,
.third,
.comment-1,
.comment-2,
.comment-3 {
  width: calc(33% - 2px);
}

.quiz-header:after,
.stepList:after {
  content: "";
  clear: both;
  display: table;
}

.stepList li {
  position: relative;
  margin-right: 2px;
  margin-bottom: 0;
  display: inline-block;
  padding: 10px 20px;
  color: #fff;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: var(--color-content-heading);
  height: 40px;
  line-height: 1.5;
}

.stepList li:hover,
.stepList li.item-completed {
  background-color: var(--color-content-primary);
  color: white;
}

.stepList li:hover:after,
.stepList li.item-completed::after {
  border-left: 10px solid var(--color-content-primary);
  color: white;
}

.stepList li:after {
  content: "";
  position: absolute;
  top: 0;
  right: -10px;
  border-top: 20px inset transparent;
  border-bottom: 20px inset transparent;
  border-left: 10px solid var(--color-content-heading);
  z-index: 10;
}

.stepList li:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border-top: 20px inset transparent;
  border-bottom: 20px inset transparent;
  border-left: 10px solid white;
}

.stepList li:first-child:before {
  display: none;
}

@media only screen and (max-width: 1024px) {
  .step-comment {
    padding: 0.5rem;
    font-size: 0.6rem;
  }

  .content div div {
    width: 100% !important;
  }
}

</style>